// const firebaseConfig = {
//     apiKey: "AIzaSyAyXAjYP7sJwk-k_m8fDCCn-X4P2eSVCg0",
//     authDomain: "onerock-vag-website.firebaseapp.com",
//     databaseURL: "https://onerock-vag-website.firebaseio.com",
//     projectId: "onerock-vag-website",
//     storageBucket: "onerock-vag-website.appspot.com",
//     messagingSenderId: "397342404439",
//     appId: "1:397342404439:web:7bd0e88813a6c9ea435812"
//   };


  import firebase from 'firebase';

  const firebaseapp = firebase.initializeApp({
    apiKey: "AIzaSyAyXAjYP7sJwk-k_m8fDCCn-X4P2eSVCg0",
    authDomain: "onerock-vag-website.firebaseapp.com",
    databaseURL: "https://onerock-vag-website.firebaseio.com",
    projectId: "onerock-vag-website",
    storageBucket: "onerock-vag-website.appspot.com",
    messagingSenderId: "397342404439",
    appId: "1:397342404439:web:7bd0e88813a6c9ea435812"
  });
  
  
  const db = firebaseapp.firestore();
  const auth = firebase.auth();
  const storage = firebase.storage();
  
  export { db, auth, storage };


// WEBPACK FOOTER //
// ./src/config/firebase.js